import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-link\"><path d=\"M15.203 0H9.41a.724.724 0 0 0 0 1.448h4.044l-7.45 7.451a.724.724 0 1 0 1.023 1.024l7.452-7.451v4.043a.724.724 0 0 0 1.448 0V.724c0-.4-.325-.724-.724-.724z\" /><path d=\"M12.307 7.24c-.4 0-.724.323-.724.723v6.515H1.448V4.344h6.515a.724.724 0 0 0 0-1.448H.724c-.4 0-.724.324-.724.724v11.582c0 .4.324.724.724.724h11.583c.4 0 .724-.324.724-.724V7.963c0-.4-.324-.724-.724-.724z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol